__turbopack_context__.v({
  "content": "XPLnua_content",
  "faqFeedback": "XPLnua_faqFeedback",
  "headline": "XPLnua_headline",
});
